import { Injectable } from '@angular/core';
import {
  NbComponentStatus,
  NbGlobalLogicalPosition,
  NbGlobalPhysicalPosition,
  NbGlobalPosition,
  NbToastrService,
} from '@nebular/theme';

@Injectable({
  providedIn: 'root'
})
export class ToastrAppSrvcService {
  private toastrConfig: { status: NbComponentStatus; destroyByClick: boolean; duration: number;
    hasIcon: boolean; position: NbGlobalPosition; preventDuplicates: boolean; };

  constructor(private toastrService:NbToastrService) {
    this.toastrConfig={
      status:  "danger",
      destroyByClick: true,
      duration: 3000,
      hasIcon: true,
      position: NbGlobalLogicalPosition.BOTTOM_END,
      preventDuplicates: true
    }
  }
  ForSuccess(msg: any,){
    this.toastrConfig.status = "success";

    this.toastrService.success(msg,"Successfully updated",this.toastrConfig);
  }
  ForDanger(msg: any){
    this.toastrConfig.status = "danger";
    this.toastrService.danger(msg,"Error" , this.toastrConfig)
  }
  ForInfo(msg: any){
    this.toastrConfig.status = "info";
    this.toastrService.danger(msg,"Information" , this.toastrConfig)
  }
}
